import { useState } from "react";
import "./NewFooter.css";
import logo from '../Images/logo.png'
import footerImg from '../Images/fotter_logo.png'

function LinkedInIcon() {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-label="LinkedIn">
      <path d="M20.45 20.45h-3.56v-5.57c0-1.33-.03-3.04-1.85-3.04-1.85 0-2.13 1.45-2.13 2.94v5.67H9.35V9h3.41v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28zM5.34 7.43a2.07 2.07 0 1 1 0-4.14 2.07 2.07 0 0 1 0 4.14zm1.78 13.02H3.56V9h3.56v11.45zM22.22 0H1.77C.79 0 0 .77 0 1.73v20.54C0 23.23.79 24 1.77 24h20.45C23.2 24 24 23.23 24 22.27V1.73C24 .77 23.2 0 22.22 0z" />
    </svg>
  );
}

// function YouTubeIcon() {
//   return (
//     <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-label="YouTube">
//       <path d="M23.5 6.2a3.01 3.01 0 0 0-2.12-2.13C19.56 3.6 12 3.6 12 3.6s-7.56 0-9.38.47A3.01 3.01 0 0 0 .5 6.2 31.6 31.6 0 0 0 0 12a31.6 31.6 0 0 0 .5 5.8 3.01 3.01 0 0 0 2.12 2.13C4.44 20.4 12 20.4 12 20.4s7.56 0 9.38-.47a3.01 3.01 0 0 0 2.12-2.13A31.6 31.6 0 0 0 24 12a31.6 31.6 0 0 0-.5-5.8zM9.75 15.52V8.48L15.82 12l-6.07 3.52z" />
//     </svg>
//   );
// }

// function TwitterIcon() {
//   return (
//     <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-label="Twitter / X">
//       <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
//     </svg>
//   );
// }

function InstagramIcon() {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-label="Instagram">
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.366.062 2.633.334 3.608 1.308.975.975 1.246 2.242 1.308 3.608.058 1.266.07 1.646.07 4.85s-.012 3.584-.07 4.85c-.062 1.366-.334 2.633-1.308 3.608-.975.975-2.242 1.246-3.608 1.308-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.366-.062-2.633-.334-3.608-1.308-.975-.975-1.246-2.242-1.308-3.608C2.175 15.584 2.163 15.204 2.163 12s.012-3.584.07-4.85c.062-1.366.334-2.633 1.308-3.608C4.516 2.497 5.783 2.225 7.15 2.163 8.416 2.105 8.796 2.163 12 2.163zm0-2.163C8.741 0 8.333.014 7.053.072 5.775.131 4.602.425 3.635 1.392 2.668 2.36 2.374 3.532 2.315 4.81 2.257 6.09 2.243 6.499 2.243 9.757v4.486c0 3.258.014 3.667.072 4.947.059 1.278.353 2.45 1.32 3.418.967.967 2.14 1.261 3.418 1.32 1.28.058 1.689.072 4.947.072s3.667-.014 4.947-.072c1.278-.059 2.45-.353 3.418-1.32.967-.967 1.261-2.14 1.32-3.418.058-1.28.072-1.689.072-4.947V9.757c0-3.258-.014-3.667-.072-4.947-.059-1.278-.353-2.45-1.32-3.418C19.398.425 18.225.131 16.947.072 15.667.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324A6.162 6.162 0 0 0 12 5.838zm0 10.162a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.88 1.44 1.44 0 0 0 0-2.88z" />
    </svg>
  );
}

export default function Footer() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  function handleSubscribe(e) {
    e.preventDefault();
    if (email) {
      setSubmitted(true);
      setName("");
      setEmail("");
    }
  }

  return (
    <footer className="footer">
      <div className="footer__bg-overlay" />

      <div className="footer__content">
        {/* Column 1 — Logo + Contact */}
        <div className="footer__col footer__col--brand">
          <a href="/" className="footer__logo">
            <div className="footer__logo-icon">
              
              <img src={logo} alt="logo" />
            </div>
            <div className="logo_img">
            </div>
          </a>

          <div className="footer__get-in-touch">
            <h4 className="footer__section-title">GET IN TOUCH</h4>
            <div className="footer__contact-item">
              <span className="footer__contact-icon">📞</span>
              <span>+234 8112 790 741</span>
            </div>
            <div className="footer__contact-item">
              <span className="footer__contact-icon">✉</span>
              <span className="footer__email">info@jeyshawnng.com</span>
            </div>
            <div className="footer__contact-item">
              <span className="footer__contact-icon">✉</span>
              <span className="footer__email">jeyshawn2012@gmail.com</span>
            </div>
            <div className="footer__contact-item">
              <span className="footer__contact-icon">✉</span>
              <span className="footer__email">jeyshawn@yahoo.com</span>
            </div>

            <div className="footer__socials">
              <a href="https://www.linkedin.com/company/jeyshawn-eng-limited-jel/?viewAsMember=true " className="footer__social-btn" aria-label="LinkedIn"><LinkedInIcon /></a>
              {/* <p className="footer__social-btn"><LinkedInIcon /></p> */}
              {/* <a href="#" className="footer__social-btn" aria-label="YouTube"><YouTubeIcon /></a> */}
              {/* <p className="footer__social-btn"><YouTubeIcon /></p> */}
              {/* <a href="#" className="footer__social-btn" aria-label="Twitter"><TwitterIcon /></a> */}
              {/* <p className="footer__social-btn"><TwitterIcon /></p> */}
              <a href="https://www.instagram.com/jeyshawn_engineering_ltd?igsh=MWNtbmNrOXJqbG8yMw==" className="footer__social-btn" aria-label="Instagram"><InstagramIcon /></a>
              {/* <p className="footer__social-btn"><InstagramIcon /></p> */}
            </div>
          </div>
        </div>

        {/* Column 2 — Addresses */}
        <div className="footer__col footer__col--addresses">
          <div className="footer__address-block">
            <h4 className="footer__section-title">CORPORATE HEADQUARTER</h4>
            <p>23A/15A Abayomi Shonuga Crescent, Lekki Phase 1, Lagos State, Nigeria.</p>
          </div>

          <div className="footer__address-block">
            <h4 className="footer__section-title">OPERATIONAL OFFICE</h4>
            <p>344 Akhigbe Road, Trans-Amadi Industrial Layout, Port Harcourt, Rivers State, Nigeria.</p>
          </div>
        </div>

        {/* Column 3 — Newsletter */}
        <div className="footer__col footer__col--newsletter">
          <h4 className="footer__section-title">NEWSLETTER</h4>

          {submitted ? (
            <p className="footer__success">Thank you for subscribing!</p>
          ) : (
            <form className="footer__form" onSubmit={handleSubscribe} noValidate>
              <input
                type="text"
                className="footer__input"
                placeholder="Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <input
                type="email"
                className="footer__input"
                placeholder="Your Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <button type="submit" className="footer__subscribe-btn">
                SUBSCRIBE
              </button>
            </form>
          )}
          
        <div className="footer_img">
          <img src={footerImg} alt="img" />
        </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="footer__bottom">
        <p>Copyright (c) {new Date().getFullYear()}. Jeyshawn Engineering Limited. All Rights Reserved</p>
      </div>
    </footer>
  );
}